var App = App || {};

App.Animations = (function ($) {
    'use strict';

    function ZagScrollAnimate() {

        $(".block.block-homepagebanner").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".homepagebanner-card", type: "animate__fadeInRight", stagger: 0 }
            ]
        });

        $(".block.block-promo-grid").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".promo-cards > .card-wrapper", type: "animate__fadeInUp", stagger: 100 }
            ]
        });

        $(".block.block-awardsband").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: "img.logo-circles", type: "animate__fadeInLeft", stagger: 0 },
                { selector: ".cards-wrapper", type: "animate__fadeInRight", stagger: 0 }
            ]
        });

        $(".block.block-membershipband").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: "img.logo-circles", type: "animate__fadeInLeft", stagger: 0 },
                { selector: ".text-content", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".block.block-blognewsband").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".featuredpost-card-wrapper", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".block.block-eventsband").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: "img.logo-circles", type: "animate__fadeInLeft", stagger: 0 },
                { selector: ".cards-list.animate-together .eventsband-card", type: "animate__fadeInUp", stagger: 0 },
                { selector: ".cards-list.animate-stagger .eventsband-card", type: "animate__fadeInUp", stagger: 100 }
            ]
        });

        $(".vertical-eventsband").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".cards-wrapper", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".block.block-relatedtopics").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: "img.logo-circles", type: "animate__fadeInLeft", stagger: 0 },
                { selector: ".topicpromo-card", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".blog-posts-list-wrapper").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".blog-post-card", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".block.block-blog-post-related").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".blog-post-card", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".block.block-subpage-list .subpages.robust").ZagScrollAnimate({
            offset: 90,
            targets: [
                { selector: ".subpage-card", type: "animate__fadeInUp", stagger: 150 }
            ]
        });

        $(".block.block-subpage-list .subpages.simple").ZagScrollAnimate({
            offset: 90,
            targets: [
                { selector: ".subpage-card", type: "animate__fadeInUp", stagger: 66 }
            ]
        });

        $(".block.block-bios").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".block-bios-items > div", type: "animate__fadeInUp", stagger: 200 }
            ]
        });

        $(".block.block-notifications").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".notification-box-wrapper", type: "animate__fadeInUp", stagger: 150 }
            ]
        });
    }

    return {
        ZagScrollAnimate: ZagScrollAnimate
    };

})(jQuery);

$(function () {
    App.Animations.ZagScrollAnimate();
});